module.exports = __webpack_public_path__ + "img/icon_server_center.16f14c8b.svg";